import { Component } from "react";
import PropTypes from "prop-types";
import constants from "../../utils/constants";

const stepPaths = {
  STEP0: "STEP0",
  STEP1: "STEP1",
  STEP2: "STEP2",
  STEP3: "STEP3",
  CONFIRMATION: "CONFIRMATION",
  CANCELLATION: "CANCELLATION",
};

const staticVariables = {
  STEP0: {
    PAGE_TITLE: "proceso de reserva hotel",
    PAGE_CATEGORY: "proceso de reserva de hotel",
    PAGE_SUBCATEGORY: "Step 0 - selección hotel",
    VIEW_NAME: "CHECKOUT_PROCESS_VIEW",
    VIEW_TYPE: "CHECKOUT-HOTEL",
  },
  STEP1: {
    PAGE_TITLE: "proceso de reserva hotel",
    PAGE_CATEGORY: "proceso de reserva hotel",
    PAGE_SUBCATEGORY: "Step 1-selección habitación",
    VIEW_NAME: "CHECKOUT_PROCESS_VIEW",
    VIEW_TYPE: "CHECKOUT-SELECCION_HABITACION",
  },
  STEP2: {
    PAGE_TITLE: "proceso de reserva hotel",
    PAGE_CATEGORY: "proceso de reserva hotel",
    PAGE_SUBCATEGORY: "Step 2-personalizar estancia y datos personales",
    VIEW_NAME: "CHECKOUT_PROCESS_VIEW",
    VIEW_TYPE: "CHECKOUT-DATOS_RESERVAINFORMACION_PERSONAL",
  },
  STEP3: {
    PAGE_TITLE: "proceso de reserva hotel",
    PAGE_CATEGORY: "proceso de reserva hotel",
    PAGE_SUBCATEGORY: "Step 3-datos de pago",
    VIEW_NAME: "CHECKOUT_PROCESS_VIEW",
    VIEW_TYPE: "CHECKOUT-DATOS_RESERVA-DATOS_PAGO",
  },
  CONFIRMATION: {
    PAGE_TITLE: "booking confirmation",
    PAGE_CATEGORY: "booking confirmation",
    PAGE_SUBCATEGORY: "Step 4-confirmación de la reserva",
    VIEW_NAME: "CHECKOUT_ORDER_CONFIRMATION",
    VIEW_TYPE: "CHECKOUT-CONFIRMATION",
  },
  CANCELLATION: {
    PAGE_TITLE: "booking cancellation",
    PAGE_CATEGORY: "booking cancellation",
    PAGE_SUBCATEGORY: "cancelación de la reserva",
    VIEW_NAME: "CHECKOUT_ORDER_CANCELLATION",
    VIEW_TYPE: "CHECKOUT-CANCELLATION",
  },
};

const propertyParams = {
  mnr: { type: "resort", origin: "MNR" },
  mediterraneanpalace: { type: "resort", origin: "MNR" },
  cleopatrapalace: { type: "resort", origin: "MNR" },
  siranthonyhotel: { type: "hotel", origin: "SA" },
  hdc: { type: "resort", origin: "HDC" },
  hoteldoncarlos: { type: "resort", origin: "HDC" },
  deluxevillas: { type: "resort", origin: "HDC" },
  theoasis: { type: "resort", origin: "ODC" },
  sofiabcn: { type: "urbano", origin: "HSB" },
  sofia: { type: "urbano", origin: "HSB" },
  torrecatalunya: { type: "urbano", origin: "HTC" },
  expobarcelona: { type: "urbano", origin: "EHB" },
  expovalencia: { type: "urbano", origin: "EHV" },
  wish: { type: "urbano", origin: "HSB" },
  demo_devs: { type: "urbano", origin: "DVS" },
  benalma: { type: "hotel", origin: "BEN" },
};

const paymentTypes = {
  CREDIT_CARD_VAULT: "Credit Card",
  TRANSFER: "Transferencia",
  PAYPAL_EXPRESS_CHECKOUT: "Paypal",
  PAYPAL_EXPRESS_STANDARD: "Paypal",
  POS: "TPV",
  SIPAY_TOKENIZED_VAULT: "PayNoPain",
};

function dataLayerPush(data) {
  if (window && window.dataLayer) {
    window.dataLayer.push(data);
  } else {
    window.dataLayer = [data];
  }
}

// Executed on chain's property selection
function dataLayerStepZeroPush({ eventAction, eventLabel }) {
  dataLayerPush({
    eventCategory: "Step 0",
    eventAction,
    eventLabel,
    event: "Step 0",
  });
}

// Executed on room selection
function dataLayerStepOnePush({ eventAction, eventLabel }) {
  dataLayerPush({
    eventCategory: "Step 1",
    eventAction,
    eventLabel,
    event: "step 1",
  });
}

// Executed on checkout
function dataLayerStepTwoPush({ eventAction, eventLabel }) {
  dataLayerPush({
    eventCategory: "Step 2",
    eventAction,
    eventLabel,
    event: "Step 2",
  });
}

// Executed on payment form
function dataLayerStepThreePush({ eventAction, eventLabel }) {
  dataLayerPush({
    eventCategory: "Step 3",
    eventAction,
    eventLabel,
    event: "Step 3",
  });
}

// Executed on tracking reservation
function dataLayerConfirmationPush({ eventAction, eventLabel }) {
  dataLayerPush({
    eventCategory: "trackTrans",
    eventAction,
    eventLabel,
    event: "trackTrans",
  });
}

// Executed on every page change
function dataLayerFunnelPush(eventLabel) {
  let url = window.location.protocol + "//" + window.location.host + window.location.pathname;

  if (url.substr(url.length - 1) !== "/") {
    url += "/";
  }

  dataLayerPush({
    eventCategory: "Pagina virtual",
    eventAction: "UAPagepath",
    eventLabel: url + eventLabel,
    event: "funnelVirtualPage",
  });
}

function getOccupantsLabel(isCheckAvailability) {
  const occupantsLabel = [];
  if (window.wbkSeniors || window.wbkSeniors === 0) {
    occupantsLabel.push(`Seniors ${window.wbkSeniors}`);
  }

  if (window.wbkAdults || window.wbkAdults === 0) {
    if (isCheckAvailability) {
      occupantsLabel.push(`adultos ${window.wbkAdults}`);
    } else {
      occupantsLabel.push(`Adultos ${window.wbkAdults}`);
    }
  }

  if (window.wbkTeenagers || window.wbkTeenagers === 0) {
    occupantsLabel.push(`Jóvenes ${window.wbkTeenagers}`);
  }

  if (window.wbkChildren || window.wbkChildren === 0) {
    if (isCheckAvailability) {
      occupantsLabel.push(`ninos ${window.wbkChildren}`);
    } else {
      occupantsLabel.push(`Niños ${window.wbkChildren}`);
    }
  }

  if (window.wbkBabies || window.wbkBabies === 0) {
    if (isCheckAvailability) {
      occupantsLabel.push(`bebes ${window.wbkBabies}`);
    } else {
      occupantsLabel.push(`Bebés ${window.wbkBabies}`);
    }
  }

  return occupantsLabel.join(" | ");
}

// Executed when user checks availability on booking form.
// Track all data on booking form separatedly by several dataLayer push (dates, occupants...)
function dataLayerFastBookingPush({ propertyName, startDate, endDate, nights, advance }) {
  const eventCategory = `Fast Booking ${propertyName}`;

  // Dates
  dataLayerPush({
    eventCategory,
    eventAction: "Fechas",
    eventLabel: `Entrada ${startDate} | Salida ${endDate}`,
    event: "fastBookingFechas",
  });

  // Nights
  dataLayerPush({
    eventCategory,
    eventAction: "Noches",
    eventLabel: nights,
    event: "fastBookingNoches",
  });

  // Booking advance
  dataLayerPush({
    eventCategory,
    eventAction: "Antelacion",
    eventLabel: advance,
    event: "fastBookingAntelacion",
  });

  // Occupants
  dataLayerPush({
    eventCategory,
    eventAction: "Huespedes",
    eventLabel: getOccupantsLabel(),
    event: "fastBookingHuespedes",
  });

  // Concatenated
  dataLayerPush({
    eventCategory,
    eventAction: "Concatenado",
    eventLabel:
      `Noches ${nights} | Huespedes ${getOccupantsLabel()} | Antelacion ${advance} | ` +
      `Fechas Entrada ${startDate} | Salida ${endDate}`,
    event: "fastBookingConcatenado",
  });
}

class BMindTracker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initDataLayer: false,
    };

    this.initDataLayer = this.initDataLayer.bind(this);
  }

  componentDidMount() {
    let path = stepPaths.STEP1;

    if (window.wbkIsPropertyChain) {
      path = stepPaths.STEP0;
    }

    switch (this.props.currentStep) {
      case "availability":
        if (this.props.expandedBookables) {
          path = stepPaths.STEP2;
        }
        break;

      case "checkout":
        path = stepPaths.STEP2;
        break;

      case "step3":
        path = stepPaths.STEP3;
        break;

      case "booking-confirmation":
        path = stepPaths.CONFIRMATION;
        break;

      default:
        break;
    }

    this.initDataLayer(path);

    // Lands on chain's property selection
    window.addEventListener(constants.EVENTS.START_STEP_ZERO, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.STEP0);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerFunnelPush("step0");

      dataLayerStepZeroPush({
        eventAction: "Inicio de proceso Step 0",
        eventLabel: window.wbkPropertyName,
      });
    });

    // Lands on room selection
    window.addEventListener(constants.EVENTS.START_STEP_ONE, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.STEP1);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerFunnelPush("step1");

      dataLayerStepOnePush({
        eventAction: "inicio de proceso step 1",
        eventLabel: window.wbkPropertyName,
      });
    });

    // Selected chain's property
    window.addEventListener(constants.EVENTS.CONTINUE_STEP_ZERO, () => {
      dataLayerStepZeroPush({
        eventAction: "continuar",
        eventLabel: "paso siguiente",
      });
    });

    // Selected room
    window.addEventListener(constants.EVENTS.CONTINUE_STEP_ONE, () => {
      dataLayerStepOnePush({
        eventAction: "continuar",
        eventLabel: "paso siguiente",
      });
    });

    // Checked availability
    window.addEventListener(constants.EVENTS.CHECKED_AVAILABILITY, () => {
      dataLayerFastBookingPush({
        propertyName: window.wbkPropertyName,
        startDate: window.wbkStartDate,
        endDate: window.wbkEndDate,
        nights: window.wbkNights,
        advance: window.wbkAdvance,
        occupants: {
          seniors: window.wbkSeniors,
          adults: window.wbkAdults,
          teenagers: window.wbkTeenagers,
          children: window.wbkChildren,
          babies: window.wbkBabies,
        },
      });
    });

    // Changed booking form and searched on a chain
    window.addEventListener(constants.EVENTS.CHANGED_BOOKING_FORM_CHAIN, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.STEP0);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerStepOnePush({
        eventAction: "Inicio de proceso Step 0",
        eventLabel: window.wbkPropertyName,
      });
    });

    // Changed booking form and searched
    window.addEventListener(constants.EVENTS.CHANGED_BOOKING_FORM, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.STEP1);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerStepOnePush({
        eventAction: "inicio de proceso step 1",
        eventLabel: window.wbkPropertyName,
      });
    });

    // No availability
    window.addEventListener(constants.EVENTS.NO_AVAILABILITY, () => {
      if (window.wbkIsPropertyAvailable === false) {
        dataLayerPush({
          eventCategory: `No disponibilidad ${window.wbkPropertyName}`,
          eventAction: getOccupantsLabel(true),
          eventLabel: `entrada ${window.wbkStartDate} | salida ${window.wbkEndDate}`,
          event: "noDisponibilidad",
        });
      }
    });

    // Comparing prices
    window.addEventListener(constants.EVENTS.COMPARING_PRICES, () => {
      dataLayerPush({
        eventCategory: "Comparar Precios",
        eventAction: window.wbkAccommodationName,
        eventLabel: window.wbkConditionName,
        event: "compararPrecios",
      });
    });

    // Expanded inventory
    window.addEventListener(constants.EVENTS.EXPANDED_INVENTORY, () => {
      dataLayerStepTwoPush({
        eventAction: "Elige tu habitacion",
        eventLabel: window.wbkAccommodationName,
      });
    });

    // Added reservation
    window.addEventListener(constants.EVENTS.ADDED_RESERVATION, () => {
      dataLayerStepTwoPush({
        eventAction: "continuar",
        eventLabel: "paso siguiente",
      });
    });

    // Lands on checkout
    window.addEventListener(constants.EVENTS.START_STEP_TWO, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.STEP2);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerFunnelPush("step2");

      dataLayerStepTwoPush({
        eventAction: "inicio de proceso step 2",
        eventLabel: window.wbkPropertyName,
      });
    });

    // Lands on payment form
    // TODO: push payment errors
    window.addEventListener(constants.EVENTS.START_STEP_THREE, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.STEP3);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerFunnelPush("step3");

      dataLayerStepThreePush({
        eventAction: "inicio de proceso step 3",
        eventLabel: window.wbkPropertyName,
      });
    });

    // Confirmed reservation
    window.addEventListener(constants.EVENTS.CONTINUE_STEP_THREE, () => {
      dataLayerStepThreePush({
        eventAction: "Confirmar",
        eventLabel: "paso siguiente",
      });
    });

    // Payment error
    window.addEventListener(constants.EVENTS.PAYMENT_ERROR, () => {
      dataLayerStepThreePush({
        eventAction: "Error en formulario",
        eventLabel: "Error",
      });
    });

    // Opened payment modal
    window.addEventListener(constants.EVENTS.PAYMENT_MODAL, () => {
      let paymentModalPhase;

      switch (window.wbkPaymentModalPhase) {
        case constants.PAYMENT_MODAL_PHASES.START:
          paymentModalPhase = "Inicio";
          break;

        case constants.PAYMENT_MODAL_PHASES.CONTINUE:
          paymentModalPhase = "Continuar";
          break;

        case constants.PAYMENT_MODAL_PHASES.ERROR:
          paymentModalPhase = "Error";
          break;

        case constants.PAYMENT_MODAL_PHASES.CLOSE:
          paymentModalPhase = "Cerrar";
          break;

        default:
          break;
      }

      dataLayerPush({
        eventCategory: "Tarjeta de credito como garantia",
        eventAction: paymentModalPhase,
        eventLabel: window.wbkPropertyName,
        event: "garantiaTarjeta",
      });
    });

    // Lands on booking confirmation
    window.addEventListener(constants.EVENTS.RESERVATION_RECEIPT, () => {
      dataLayerFunnelPush("confirmacion");
    });

    // Track reservation
    window.addEventListener(constants.EVENTS.RESERVATION_SUCCESS, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.CONFIRMATION);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerConfirmationPush({
        eventAction: "fin de proceso success",
        eventLabel: window.wbkPropertyName,
      });

      dataLayerConfirmationPush({
        eventAction: "ID de reserva",
        eventLabel: window.wbkReservationId,
      });
    });

    // Cancel reservation
    window.addEventListener(constants.EVENTS.CANCEL_RESERVATION, () => {
      if (this.state.initDataLayer) {
        this.initDataLayer(stepPaths.CANCELLATION);
      } else {
        this.setState({ initDataLayer: true });
      }

      dataLayerPush({
        eventCategory: window.wbkPropertyName,
        eventAction: "cancelacion",
        event: "reservaCancelada",
      });
    });
  }

  initDataLayer(currentStep) {
    const {
      wbkDataLayer: {
        pageTitle,
        pageLang,
        propertyName,
        customPropertyName,
        propertyValuation,
        propertyDestination,
        destinationName,
        totalChildren,
        totalAdults,
        totalBabies,
        totalRooms,
        roomName,
        startDate,
        endDate,
        totalNights,
        conditionName,
        mealPlanName,
        promotionName,
        promoCodes,
        services,
        paymentError,
        totalAdvance,
        amountRoom,
        amount,
        checkedAvailability,
        transactionCardType,
        transactionId,
        transactionDate,
        transactionAffiliation,
        transactionTotal,
        transactionTotalCents,
        transactionShipping,
        transactionTax,
        transactionPaymentType,
        transactionCurrency,
        transactionZip,
        transactionShippingMethod,
        transactionPromoCode,
        transactionProducts,
        searchDestination,
        checkInDate,
        checkOutDate,
        searchCheapestInfo,
        tacurrency,
        tabr,
        tatf,
        tapi,
      },
      propertyTicker,
      origin,
    } = this.props;

    let funnelVirtualPage =
      window.location.protocol + "//" + window.location.host + window.location.pathname;

    if (funnelVirtualPage.substr(funnelVirtualPage.length - 1) !== "/") {
      funnelVirtualPage += "/";
    }

    switch (currentStep) {
      case stepPaths.STEP0:
        funnelVirtualPage += "step0";
        break;

      case stepPaths.STEP1:
        funnelVirtualPage += "step1";
        break;

      case stepPaths.STEP2:
        funnelVirtualPage += "step2";
        break;

      case stepPaths.STEP3:
        funnelVirtualPage += "step3";
        break;

      case stepPaths.CONFIRMATION:
        funnelVirtualPage += "confirmation";
        break;

      case stepPaths.CANCELLATION:
        funnelVirtualPage += "cancellation";
        break;

      default:
        break;
    }

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    let bMindOrigin = "EHR";
    window.wbkOrigin = "EHR";

    if (origin && origin !== "meta") {
      bMindOrigin = origin;
      window.wbkOrigin = origin;
    } else if (propertyParams[propertyTicker] && propertyParams[propertyTicker].origin) {
      bMindOrigin = propertyParams[propertyTicker].origin;
      window.wbkOrigin = propertyParams[propertyTicker].origin;
    }

    const isFirstStep = currentStep === stepPaths.STEP1 || currentStep === stepPaths.STEP0;
    const isConfirmation = currentStep === stepPaths.CONFIRMATION;

    const busquedaDiasAntelacion = isFirstStep ? totalAdvance : "";
    const busquedaTotalNinos = isFirstStep ? totalChildren : "";

    window.dataLayer.push({
      event: "pageview",
      pageTitle: pageTitle + " | " + staticVariables[currentStep].PAGE_TITLE, // expo hotels | proceso de reserva hotel
      pageCategory: staticVariables[currentStep].PAGE_CATEGORY, // proceso de reserva hotel
      pageSubCategory: staticVariables[currentStep].PAGE_SUBCATEGORY, // Step 3-datos de pago
      viewName: staticVariables[currentStep].VIEW_NAME,
      viewType: staticVariables[currentStep].VIEW_TYPE,
      pageLang,
      hotelNom: propertyName,
      hotelType: (propertyParams[propertyTicker] && propertyParams[propertyTicker].type) || "", // To be specified
      hotelCategoria: propertyValuation || "", // '5 estrellas'/'4 estrellas'/'3 estrellas' depending on property
      hotelDestino: propertyDestination, // Marbella
      busquedaDestino: (isFirstStep && searchDestination) || "",
      busquedaZonaNom: (isFirstStep && propertyDestination) || "",
      busquedahotelNom: customPropertyName || "",
      busquedaHotelType:
        (isFirstStep && propertyParams[propertyTicker] && propertyParams[propertyTicker].type) ||
        "",
      busquedaFechaIni_ddmmyy: (isFirstStep && startDate) || "",
      busquedaFechaFin_ddmmyy: (isFirstStep && endDate) || "",
      busquedaDiasAntelacion,
      busquedaTotalNoches: (isFirstStep && totalNights) || "",
      busquedaTotalAdultos: (isFirstStep && totalAdults) || "",
      busquedaTotalNinos,
      busquedaDisponibilidad:
        (isFirstStep && ((window.wbkIsPropertyAvailable && "SI") || "No")) || "",
      busquedaOrigen: bMindOrigin || "",
      destinoNom: destinationName, // marbella
      resTotalNinos: parseInt(totalChildren, 10), // Total of all bookings
      resTotalAdultos: parseInt(totalAdults, 10), // Total of all bookings
      resTotalBebes: parseInt(totalBabies, 10), // Total of all bookings
      resNumHabs: totalRooms, // Total of all bookings
      resHotelNom: propertyName,
      resHabNom: roomName, // Room names concatenated with " | " when multireservation
      resFechaIni: startDate,
      resFechaFin: endDate,
      checkin_date: checkInDate,
      checkout_date: checkOutDate,
      resTotalNoches: totalNights, // Total of all bookings
      resTarifaNom: conditionName, // Condition names concatenated with " | " when multireservation
      resRegimenType: mealPlanName, // Meal plan names concatenated with " | " when multireservation
      resOfferNom: promotionName, // Promotion names concatenated with " | "
      resPromoCode: (promoCodes && "SI") || "NO",
      resServExtras: services, // Service names concatenated with " | "
      resErrorDatosPago: paymentError,
      resDiasAntelacion: totalAdvance,
      resOrigin: bMindOrigin,
      resPrecioHab: amountRoom || "", // Precio total || Precio por noche
      resPrecio: amount || "", // Total prices concatenated with " | " when multireservation
      searchCheapestInfo,
      lookToBook: checkedAvailability, // True if user consulted disponibility
      FunnelVirtualPage: funnelVirtualPage,
      tacurrency,
      tabr,
      tatf,
      tapi,
      transactionCardNom: (isConfirmation && transactionCardType) || "",
      transactionId: (isConfirmation && transactionId) || "",
      transactionDate: (isConfirmation && transactionDate) || "",
      transactionAffiliation: (isConfirmation && transactionAffiliation) || "",
      transactionTotal: (isConfirmation && transactionTotal) || "",
      transactionTotalCents: (isConfirmation && transactionTotalCents) || "",
      transactionShipping: (isConfirmation && transactionShipping) || "",
      transactionTax: (isConfirmation && transactionTax) || "", // Total price
      transactionPaymentType: (isConfirmation && paymentTypes[transactionPaymentType]) || "", // Credit Card || Paypal ...
      transactionCurrency: (isConfirmation && transactionCurrency) || "",
      transactionZIP: (isConfirmation && transactionZip) || "",
      transactionShippingMethod: (isConfirmation && transactionShippingMethod) || "",
      transactionPromoCode: (isConfirmation && transactionPromoCode) || "",
      transactionProducts:
        (isConfirmation &&
          transactionProducts &&
          transactionProducts.map(product => {
            return {
              sku: product.id,
              name: product.name,
              category: product.category,
              price: product.amount,
              quantity: product.rooms,
            };
          })) ||
        "",
    });

    window.dataLayer.push({ event: "pushloaded" });
  }

  render() {
    return false;
  }
}

BMindTracker.propTypes = {
  wbkDataLayer: PropTypes.object,
  propertyTicker: PropTypes.string,
  pageTitle: PropTypes.string,
  pageCategory: PropTypes.string,
  pageSubCategory: PropTypes.string,
  pageLang: PropTypes.string,
  propertyName: PropTypes.string,
  propertyType: PropTypes.string,
  propertyValuation: PropTypes.string,
  propertyDestination: PropTypes.string,
  destinationName: PropTypes.string,
  totalChildren: PropTypes.number,
  totalAdults: PropTypes.number,
  totalBabies: PropTypes.number,
  totalRooms: PropTypes.number,
  roomName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  totalNights: PropTypes.number,
  conditionName: PropTypes.string,
  mealPlanName: PropTypes.string,
  promotionName: PropTypes.string,
  promoCodes: PropTypes.string,
  services: PropTypes.string,
  paymentError: PropTypes.string,
  totalAdvance: PropTypes.number,
  origin: PropTypes.string,
  amountRoom: PropTypes.number,
  amount: PropTypes.number,
  checkedAvailability: PropTypes.string,
  transactionCardType: PropTypes.string,
  transactionId: PropTypes.string,
  transactionDate: PropTypes.string,
  transactionAffiliation: PropTypes.string,
  transactionTotal: PropTypes.string,
  transactionShipping: PropTypes.string,
  transactionTax: PropTypes.string,
  transactionPaymentType: PropTypes.string,
  transactionCurrency: PropTypes.string,
  transactionZip: PropTypes.string,
  transactionShippingMethod: PropTypes.string,
  transactionPromoCode: PropTypes.string,
  transactionProducts: PropTypes.string,
  currentStep: PropTypes.string,
  expandedBookables: PropTypes.bool,
};

export default BMindTracker;
